//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
//import trackingCode from 'trackingCode';

export default {
  layout: function layout(context) {
    return global.getTheme();
  },
  data: function data() {
    return {
      email: '',
      password: '',
      remember: 0,
      loading: false,
      paymentMethod: '',
      view: 'default'
    };
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  created: function created() {
    var _this = this;

    this.view = global.getTheme();
    global.getPaymentMethodId().then(function (value) {
      _this.paymentMethod = value;
      if (process.client && _this.$auth.isAuthenticated()) {
        _this.$router.push({ name: 'lang', params: { lang: _this.lang } });
      }

      if (_this.paymentMethod == 'tpay') {
        _this.$router.push({ name: 'lang-login-by-phone', params: { lang: _this.lang } });
      } else if (_this.paymentMethod == 'payguru') {
        _this.payguruAutoLogin();
      }
    });
  },
  mounted: function mounted() {},

  methods: {
    login: function login() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.loading = true;
          _this2.$auth.login(_this2.email, _this2.password, function () {
            this.loading = false;
            this.$router.push({ name: 'lang', params: { lang: this.lang } });
            this.$parent.$emit('login-logout-event');
          }.bind(_this2), function (err) {
            if (flash) flash(this.$root.trans('st_public.' + err.response.data.message), 'error');
            this.loading = false;
          }.bind(_this2));
        }
      });
    },
    getAllCookies: function getAllCookies() {
      if (process.client) {
        return document.cookie;
      }
      return '';
    },
    payguruAutoLogin: function payguruAutoLogin() {
      var _this3 = this;

      this.loading = true;
      var reqParams = this.$route.query;
      reqParams.registration_lang = this.lang;

      axios.get(global.getEndPoint() + 'api/payguru/autologin', { /*headers: {'X-Cookie': this.getAllCookies()}, */
        params: reqParams
      }).then(function (res) {
        _this3.loading = false;
        if (res.data.access_token) {
          _this3.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
          _this3.$parent.$emit('login-logout-event');
          _this3.$router.push({ name: 'lang-successful-signup', params: { lang: _this3.lang } });
        }
      }).catch(function (err) {
        _this3.loading = false;
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/login.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/login.vue
// module chunks = 41